import { useContext } from "react";

import { IdleContext } from "@contexts/Idle";

export const useIdleState = () => useContext(IdleContext);
